import React from 'react';
import {Flex} from '/app/src/component';
export default class TextInput extends React.Component {
    render() {
        const disabled = this.props.disabled;
        let {onChange, placeholder, value, autoComplete, name, disable, ...rest} = this.props
        return(
            <Flex
                shrink={0}
                column
                {...rest}>
                <input
                    placeholder={placeholder}
                    type='text'
                    name={name}
                    onChange={this.props.onChange}
                    value={value || ''}
                    autoComplete={autoComplete}
                    disabled={disabled}
                    />
            </Flex>
        );
    }
}



// WEBPACK FOOTER //
// src/component/Forms/TextInput/index.js